// extracted by mini-css-extract-plugin
export default {"container":"AddCapteurComposante_container__Ln+su","btn_stylo":"AddCapteurComposante_btn_stylo__BduLd"};